export const LoadTitlePage = () => {
    const title = document.getElementsByTagName("title")[0];
    const url = window.location.href;
    const uri = url.split('/');
    const host = 'Disneyland Paris';
    if (url.includes('admin')) {
        /* backoffice */
        title.innerHTML = uri[6] ? `admin - ${uri[6]} | ${host}` : `admin - ${uri[4]} | ${host}`;
    } else {
        /* frontoffice */
        if (uri[7] && uri[5] && uri[3]) {
            /* attraction */
            title.innerHTML = `${uri[7]} ${uri[5]} ${uri[3]} | ${host}`;
        } else if (uri[5] && uri[3]) {
            /* univers */
            title.innerHTML = `${uri[5]} ${uri[3]} | ${host}`;
        } else if (uri[3] && uri[4]) {
            /* category | origin */
            title.innerHTML = `${uri[3]} ${uri[4]} | ${host}`;
        } else if (uri[3]) {
            /* categories | origins */
            title.innerHTML = `${uri[3]} | ${host}`;
        } else {
            /* home */
            title.innerHTML = `attractions univers parcs | ${host}`;
        }
    }
}
